import { QueryClient } from '@tanstack/react-query';
import pageRefreshDetector from '../utils/pageRefreshDetector';

// 創建智能 QueryClient
const createQueryClient = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // 基本配置
        staleTime: 5 * 60 * 1000, // 5分鐘後認為數據過期
        cacheTime: 10 * 60 * 1000, // 緩存10分鐘
        retry: 3, // 失敗重試3次
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
        
        // 智能緩存策略
        refetchOnWindowFocus: (query) => {
          // 如果是頁面重整，強制重新獲取
          if (pageRefreshDetector.isRefresh()) {
            return true;
          }
          // 正常頁面切換時，只在數據過期時重新獲取
          return query.state.dataUpdatedAt < Date.now() - query.state.dataUpdatedAt;
        },
        
        refetchOnMount: (query) => {
          // 頁面重整時強制重新獲取
          if (pageRefreshDetector.isRefresh()) {
            return true;
          }
          // 正常頁面切換時，只在數據過期時重新獲取
          return query.state.dataUpdatedAt < Date.now() - query.state.dataUpdatedAt;
        },
        
        // 根據頁面類型調整刷新策略
        refetchInterval: (query) => {
          // 如果是頁面重整，立即刷新
          if (pageRefreshDetector.isRefresh()) {
            return 0;
          }
          
          // 根據查詢類型決定刷新間隔
          const queryKey = query.queryKey[0];
          if (queryKey === 'products') {
            return 60000; // 商品數據每分鐘刷新
          }
          if (queryKey === 'seriesOptions' || queryKey === 'systemActivityOptions') {
            return 5 * 60 * 1000; // 選項數據每5分鐘刷新
          }
          return false; // 其他數據不自動刷新
        },
        
        refetchIntervalInBackground: false, // 背景時不自動刷新
      },
      mutations: {
        retry: 1, // 變更操作只重試1次
      },
    },
  });

  // 頁面重整時清除所有緩存
  if (pageRefreshDetector.isRefresh()) {
    queryClient.clear();
    // 清除重整標記
    pageRefreshDetector.clearRefreshFlag();
  }

  return queryClient;
};

export default createQueryClient; 